/**
 * Decision logic for what to do when a new service worker is waiting.
 *
 * Split out from {@link PwaUpdater} so the per-shell branching is unit-testable
 * without importing the `virtual:pwa-register/react` module (which only exists
 * in a Vite build, not under vitest).
 */
import type { Shell } from '../shells';

export interface PwaUpdateActions {
  /** The shell the user is currently in (from `detectShell`). */
  shell: Shell;
  /** vite-plugin-pwa's updater; `updateServiceWorker(true)` activates + reloads. */
  updateServiceWorker: (reloadPage?: boolean) => void | Promise<void>;
  /** Surface the "new version — refresh" prompt (staff shells only). */
  notifyRefresh: () => void;
}

/**
 * Apply the update policy for a waiting SW:
 *  - **kiosk** — reload silently to the new build (no operator to click), and
 *  - **desktop / mobile staff** — show a refresh prompt so an in-progress form
 *    isn't yanked out from under them.
 */
export function applyPwaUpdate({
  shell,
  updateServiceWorker,
  notifyRefresh,
}: PwaUpdateActions): void {
  if (shell === 'kiosk') {
    void updateServiceWorker(true);
    return;
  }
  notifyRefresh();
}
